import Client from 'shopify-buy';

const accessToken = 'a69737b92556461e8ec23b66afdef1f3';
const domain = 'bw-restaurants-oy';
const appId = '6674972699';

export const shopClient = Client.buildClient({
  accessToken: accessToken,
  domain: domain+'.myshopify.com',
  appId: appId
});

export const getProductsInCollection = (collection) =>
  shopClient.fetchQueryProducts({ collection_id: collection })
  .then(response => response)
  .catch(function () {
    console.log('Request failed');
  });


// WEBPACK FOOTER //
// ./src/api/shopifyAPI.js